<template>
	<div class="">
		<div class="back-arrow pl-6 pt-2">
			<router-link to="/model3d">
				<i class="fa fa-fw fa-arrow-left" />
				<span> Back to Model3d </span>
			</router-link>
		</div>
		<base-page-heading
			title="3D Model Edit"
			subtitle=""
			class="d-print-none"
		>
			<template #extra>
				<b-button
					ref="btnShow"
					type="submit"
					size="lg"
					variant="secondary"
					@click="updateModel3dProperties"
				>
					Save changes
				</b-button>
			</template>
		</base-page-heading>
		<loading-overlay
			:active="isLoading"
			:can-cancel="true"
		/>

		<div class="row content">
			<EditModel3dTable ref="editmodel3d" />
		</div>
	</div>
</template>
<style scoped>
.back-arrow{
	background-color: #f6f7f8;
}
</style>
